

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { ExecutionPointerFormComponent } from './executionpointer-form/executionpointer-form.component';
import { ExecutionPointerComponent } from './executionpointer.component';
import { ExecutionPointerRoutes } from './executionpointer.routing';

export function declaration() {
    return [ExecutionPointerComponent, ExecutionPointerFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ExecutionPointerModule {
}

@NgModule({
    imports: [ExecutionPointerModule, ExecutionPointerRoutes],
    exports: [ExecutionPointerModule]
})
export class ExecutionPointerWithRouteModule {
}
